export default __webpack_public_path__ + "static/media/searchiconbg.dec795bb.svg";